module.exports = __webpack_public_path__ + "static/ollie-36e9cf39d77f704900787d588ab86d52.png";